import React, { Component } from 'react';
import moment from 'moment';
import { Input, Select, DatePicker } from 'antd';
import store from '../../../store';
import { setSearchParams } from '../../../actions/executeActions';

const Option = Select.Option;
const { MonthPicker, RangePicker } = DatePicker;
const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';

class SearchGroup extends Component {

    constructor(props) {
        super(props);
        const { searchItem } = props;
        const { moduleDefineCode, moduleDefineName, criteriaDataType, projectDefineWebType, moduleDefineConstraintValue } = searchItem || {};
        this.state = {
            moduleDefineCode,
            moduleDefineName,
            criteriaDataType,
            projectDefineWebType,
            moduleDefineConstraintValue,
            searchValue: undefined,
        };
    }

    handleChangeDatePicker = (date, dateString) => {
        if(dateString[0] == "" && dateString[1] == ""){
            dateString = '';
        }
        if(this.state){
            this.loadInterval && this.setState({
                searchValue: dateString,
            }, () => {
                this.setSearchParams();
            });
        }
    }

    handleChange = value => {
        this.loadInterval && this.setState({
            searchValue: value,
        }, () => {
            this.setSearchParams();
        });
    }

    setSearchParams = () => {
        const { moduleDefineCode } = this.state;
        store.dispatch(setSearchParams(moduleDefineCode, { ...this.state }));
    }

    getOwnState = () => {
        if(store.getState()){
            if(store.getState().executeState){
                if(store.getState().executeState.searchParams){
                    if(store.getState().executeState.searchParams[this.state.moduleDefineCode]){
                        return {
                            searchValue: store.getState().executeState.searchParams[this.state.moduleDefineCode]['searchValue']
                        }
                    }
                }
            }
        }
        return null;
    }

    onStoreChange = () => {
        if(this.getOwnState()){
            if(this.state){
                this.loadInterval && this.setState(this.getOwnState());
            }
        }else{
            if(this.state){
                this.loadInterval && this.setState({
                    searchValue: undefined
                })
            }
            
        }
    }

    componentDidMount= () => {
        store.subscribe(this.onStoreChange);
        this.loadInterval = setInterval(this.loadSearches, this.props.pollInterval);
    }

    componentWillUnmount = () => {
        store.subscribe(this.onStoreChange);
        this.loadInterval && clearInterval(this.loadInterval);
        this.loadInterval = false;
        const { moduleDefineCode } = this.state;
        store.dispatch(setSearchParams(moduleDefineCode, {}));
    }

    render() {
        const {
            moduleDefineName,
            projectDefineWebType,
            moduleDefineConstraintValue = '',
            searchValue,
        } = this.state;
        let rangepicker;
        if( projectDefineWebType === 'DATETIMEPICKER') {
            if (true) {
                const [startTime, endTime] = searchValue || [];
                const newValue = searchValue ? [moment(startTime, dateFormat), moment(endTime, dateFormat)] : [undefined,undefined];
                rangepicker = (
                    <RangePicker
                        format={dateFormat}
                        value={newValue}
                        style={{ width: 200 }}
                        onChange={this.handleChangeDatePicker}
                    />
                );
            } else {
                rangepicker = (
                    <MonthPicker
                        format={monthFormat}
                        style={{ width: 120 }}
                        value={searchValue ? moment(searchValue) : undefined}
                        onChange={(date, dateString) => this.handleChange(dateString)}
                    />
                );
            }
        }
        const options = typeof moduleDefineConstraintValue == 'string' && moduleDefineConstraintValue.split("//").map(item => <Option key={item} value={item}>{item}</Option>)

        return (
            
            <div className="form-item search-item" key={this.props.moduleDefineId}>
                <label htmlFor="" className="ui-label">{moduleDefineName}</label>
                {
                    projectDefineWebType === 'INPUT' &&
                    <Input
                        className="ui-input"
                        placeholder="请输入"
                        value={searchValue}
                        onChange={e => this.handleChange(e.target.value)}
                    />
                }
                {
                    (projectDefineWebType === 'SELECT' || projectDefineWebType === 'RADIO') &&
                    <Select
                        className="ui-input"
                        placeholder="请选择"
                        value={searchValue}
                        style={{ width: 120 }}
                        onChange={this.handleChange}
                        allowClear={true}
                    >
                        {options}
                    </Select>
                }
                {
                    projectDefineWebType === 'DATETIMEPICKER' &&
                    rangepicker
                }
            </div>
            
        );
    }
}

export default SearchGroup;




// WEBPACK FOOTER //
// ./src/components/common/searchGroup/SearchGroup.js